import {slugify, slugToCamelcase, getTitleOrSubTitle} from './overlay';
import { checkForHash } from './scrollToSection';
import { initOverlayLinks } from './overlay';

let itemBankCount = 10;
let itemDisplayCount = {};

const printFeaturedItemsLists = (list) => {
  // get html
  const listHtml = featuredItemsListHtml(list);
  // inserts posts html
  list.innerHTML = listHtml;
  initOverlayLinks();
};

const featuredItemsListHtml = (list) => {
  // get list data
  const sectionId = list.dataset.sectionId;
  const items = window[sectionId + "_featured_items"];
  const itemsCount = items.length;
  const listItemType = list.dataset.itemType ? list.dataset.itemType : 'repeater-item';

  // handle load more button
  manageLoadMoreVisibility(sectionId, itemsCount);

  if (itemsCount > 0) {
    let listHtml;
    switch(listItemType){
      case 'repeater-item':
        listHtml = featuredItemHtml(items,list);
      break;
      case 'event':
        listHtml = featuredEventHtml(items,list);
      break;
    }
    return listHtml;
  } else {
    return "";
  }
};

const featuredItemHtml = (items,list) => {
    return items
      .join(0)
      .split(0)
      .map((item, i) => {
        if (i < itemDisplayCount[list.dataset.sectionId]) {
          let linkAttributes;
          switch (items[i].type) {
            case "link":
              linkAttributes = 'href="' + items[i].url + '" target="_blank"';
              break;
            case "overlay":
              linkAttributes =
                'id="' + getTitleOrSubTitle(items[i]) + '" class="overlay-link" class="overlay-link" href="#' + getTitleOrSubTitle(items[i]) + '" data-overlay-type="discover"';
              break;
            case "video_overlay":
              linkAttributes =
                'id="' +
                getTitleOrSubTitle(items[i]) +
                '" class="overlay-link" class="overlay-link" href="#' + getTitleOrSubTitle(items[i]) + '" data-overlay-type="discover-video" data-overlay-video-type="' +
                items[i].overlayVideoType +
                '" data-overlay-vimeo-id="' +
                items[i].overlayVimeoVideoId +
                '" data-overlay-mp4="' +
                items[i].overlayMp4Video +
                '"';
              break;
          }

          return `
            <div class="featured_item">
              <a ${linkAttributes}>
                ${
            items[i].thumbnail
              ? '<span class="featured_item-image zoom-image"><span class="bg-image" style="background-image:url(' +
              items[i].thumbnail +
              ')"></span></span>'
              : ""
            }
                <div class="carousel__item-content">
                ${
            items[i].title
              ? '<h3 class="featured_item-title article-heading article-heading--small">' +
              items[i].title +
              "</h3>"
              : ""
            }
                ${
            items[i].subtitle
              ? '<h4 class="featured_item-sub-title small-title">' +
              items[i].subtitle +
              "</h4>"
              : ""
            }
                ${
            items[i].content
              ? '<div class="featured_item-content body-copy">' +
              items[i].content +
              "</div>"
              : ""
            }
                ${
            items[i].smalltype
              ? '<div class="featured_item-smalltype body-copy body-copy--small">' +
              items[i].smalltype +
              "</div>"
              : ""
            }
              </div>
              </a>
            </div>
          `;
        }
      })
      .join("");  
}

const featuredEventHtml = (items,list) => {
  return items
    .join(0)
    .split(0)
    .map((item, i) => {
      if (i < itemDisplayCount[list.dataset.sectionId]) {
        let linkAttributes = '';
        return `
          <div class="featured_item ${ items[i].isHighlighted ? `featured_item--highlight` : `` }">
            <a href="${items[i].permalink}" target="_self">
            ${ items[i].image ? `
            <span class="featured_item-image zoom-image">
              <span class="bg-image" style="background-image:url(${items[i].image})">
              ${ items[i].showLabel ? `<span class="featured_item--label">${items[i].label}</span>` : ``}
              </span>
            </span>
            ` : ``}
            <span class="featured_item-content-wrapper">
              ${ items[i].post_title ? `
              <h4 class="featured_item-sub-title small-title">${items[i].post_title}</h4>
              ` : ``}
              ${ items[i].date ? `
              <div class="featured_item-event-date body-copy">${items[i].date}</div>
              ` : ``}            
            </span>

            </a>
          </div>
        `;
      }
    })
    .join("");  
}

// Load More

// reveals & hode load more button
const manageLoadMoreVisibility = (listId, itemsCount) => {
  /*
  console.log(
    "manageLoadMoreVisibility() itemsCount:" +
    itemsCount +
    ", itemDisplayCount[listId]:" +
    itemDisplayCount[listId]
  );
  */
  // init more cta wrappers
  const featuredItemsMoreWrapper = document.getElementById(
    listId + "-featured_items__more-wrapper"
  );
  /*
   */

  if (featuredItemsMoreWrapper) {
    if (itemsCount > itemDisplayCount[listId]) {
      featuredItemsMoreWrapper.classList.add(
        "featured_items__more-wrapper--active"
      );
    } else {
      featuredItemsMoreWrapper.classList.remove(
        "featured_items__more-wrapper--active"
      );
    }
  }
};

// get all featured lists into array
const featuredItemsLists = Array.from(
  document.querySelectorAll(".featured_items--js-list")
);

// if lists array has items
if (featuredItemsLists.length > 0) {
  // loop through list items
  featuredItemsLists.forEach((list) => {
    const listId = list.dataset.sectionId;

    // init this list display items count
    itemDisplayCount[listId] = itemBankCount;

    // init more cta
    const featuredItemsMoreCta = document.getElementById(
      listId + "-featured_items__more-cta"
    );
    // add more cta event listener
    if (featuredItemsMoreCta) {
      featuredItemsMoreCta.addEventListener("click", (e) => {
        e.preventDefault();
        // increase count
        itemDisplayCount[listId] += itemBankCount;
        // reprint posts
        printFeaturedItemsLists(list);
      });
    }

    printFeaturedItemsLists(list);

    checkForHash();

  });
}
